// extracted by mini-css-extract-plugin
export var cursor = "header-module--cursor--VD9oE";
export var header = "header-module--header--UabsJ";
export var inner = "header-module--inner--Kt5+U";
export var logo = "header-module--logo--2EQRp";
export var mark = "header-module--mark--iybet";
export var right = "header-module--right--M+2oj";
export var text = "header-module--text--nE0Nm";